import { useParams } from '@remix-run/react'
import { APP_LOCALES, DEFAULT_LANGUAGE, type AppLocales } from '@constants/i18n'

// Return a correctly formatted html language attribute.

export function getLang(locale: string | undefined) {
  let language = ''
  let country = ''

  // if we support a locale, use that as the lang attribute, otherwise use default lang
  if (
    locale &&
    APP_LOCALES.includes(locale.toLocaleLowerCase() as AppLocales)
  ) {
    language = locale.slice(0, 2)
    country = locale.slice(-2)
  } else {
    language = DEFAULT_LANGUAGE
  }

  const region = country?.toUpperCase()

  return [language, region === 'EU' ? '' : region].filter(Boolean).join('-')
}

export function useGetLang() {
  const routeParams = useParams()
  const { locale } = routeParams

  return getLang(locale)
}
